import React from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { suffixMessageTags } from './const';
import { IValidationOptional } from '../../types';

const initialValidations = [
  'required',
  'password',
  'zip',
  'phone',
  'email',
  'domain',
  'should-not-start-with-www',
  'max_varchar_length',
  'min_length',
  'website',
  'salutation',
];

const ValidationMessage: React.FunctionComponent<{
  errors?: string[];
  text?: string;
  isHint?: boolean;
  maxPswLength?: number;
  fieldName?: string;
  name?: string;
  optionalParams?: IValidationOptional;
}> = ({ errors, text, isHint, maxPswLength, fieldName, name, optionalParams }) => {
  const maxVarcharLength = 191;
  const { t } = useTranslation();
  const defaultLang = typeof window !== 'undefined' && window?.location?.pathname;

  const getDefaultLang = str => str.split('/')[1];

  const suffixValidationMessage = (suffix, lang) => {
    let suffixTag: string = '';

    if (name && getDefaultLang(defaultLang) === lang) {
      suffixTag =
        suffixMessageTags[lang][suffix] || suffixMessageTags[lang][suffix] === ''
          ? suffixMessageTags[lang][suffix]
          : '';
    }
    return suffixTag;
  };

  const getErrorText = () => {
    let errorMessage: string = '';
    const updatedFieldName = fieldName
      ?.substring(0, fieldName.length - 1)
      .trim()
      .toLowerCase();

    const options = {
      suffix: suffixValidationMessage(name, getDefaultLang(defaultLang)),
      fieldName:
        getDefaultLang(defaultLang) !== 'de'
          ? fieldName
              ?.substring(0, fieldName.length - 1)
              .trim()
              .toLowerCase()
          : fieldName?.substring(0, fieldName.length - 1),
    };

    switch (errors && errors[0]) {
      case 'required':
        if (getDefaultLang(defaultLang) === 'it' && name === 'organization') {
          errorMessage = t<string>(
            'components.validation-message.field-required',
            options
          ).replace(` ${updatedFieldName}`, updatedFieldName ? updatedFieldName : '');
        } else {
          errorMessage = t<string>(
            'components.validation-message.field-required',
            options
          );
        }
        break;
      case 'password':
        errorMessage = t<string>('components.validation-message.password', {
          maxLength: maxPswLength || 8,
        });
        break;
      case 'zip':
        errorMessage = t<string>('components.validation-message.only-digits');
        break;
      case 'phone':
        errorMessage = t<string>('components.validation-message.phone');
        break;
      case 'email':
        errorMessage = t<string>('components.validation-message.email');
        break;
      case 'domain':
        errorMessage = t<string>('components.validation-message.domain');
        break;
      case 'should-not-start-with-www':
        errorMessage = t<string>(
          'components.validation-message.should-not-start-with-www'
        );
        break;
      case 'max_varchar_length':
        errorMessage = t<string>('components.validation-message.max-varchar-length', {
          maxVarcharLength,
        });
        break;
      case 'min_length':
        errorMessage = t<string>('components.validation-message.minimal-length', {
          length: optionalParams?.min_length,
        });
        break;
      case 'website':
        errorMessage = t<string>('components.validation-message.website');
        break;
      case 'salutation':
        errorMessage = t<string>('components.validation-message.salutation');
        break;
      default:
        errorMessage = t<string>('common.unknown-error');
    }
    return errorMessage;
  };

  if (!errors && !text) return null;

  return (
    <Form.Text
      className={`text-muted validation-error-message ${isHint ? 'is-hint' : ''}`}
    >
      {errors && initialValidations.indexOf(errors[0]) > -1
        ? getErrorText()
        : text || errors}
    </Form.Text>
  );
};

export default ValidationMessage;
